import clsx from 'clsx';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { LeftArrow } from '../../../icons/arrows/leftArrow';
import { CollapseIcon, ExpandIcon } from '../../../icons/expandIcon';
import { CarImageCard } from './CarImageCard';
import usePersonStore from '../../../store/personStore';
import { useServiceCarStore } from '../../../store/serviceCarStore';
import { WarningIcon } from '../../../icons/warningIcon';
import { Button } from '../../../components/ui/Button';
import { AlertBanner } from '../../../components/ui/AlertBanner';
import { CheckCircleIcon, WarningCircleIcon } from '../../../icons';
import { WheelIcon } from '../../../icons/wheelIcon';
import { useDownloadForm } from '../../../hooks/react-query/useNewService';

export const ServiceSlider = ({ state, dispatch, isTesla=false }) => {   

    const showRetailDashboard = usePersonStore(
    (store) => store.showRetailDashboard
    );

    const { carInfo } = useServiceCarStore();

    const navigate = useNavigate();

    const [expanded, setExpanded] = useState(true);

    const { refetch, isFetching } = useDownloadForm(
        'AccidentReport.pdf'
    );

    const handleAccidentReportDownloadClick = () => {
        if (!isFetching) {
            refetch();
        }
    };

    return (
        // <div className={`max-lg:hidden sticky top-0 z-10 w-fit max-h-[83vh] ${state?.step === 0 && 'mt-[63px]'}`}>
        <div className={`max-lg:hidden sticky top-0 z-10 w-fit max-h-[83vh]`}>
            <div className="flex h-full mr-[30px]">
                <div
                    className={clsx(
                        'no-scrollbar overflow-y-scroll pt-6 px-12 bg-white rounded-r-[20px] h-[100%] transition-all ease-in-out duration-300',
                        expanded ? 'w-[374px]' : 'w-[40px]'
                    )}
                    style={{
                        boxShadow: '0px 2px 2px 2px #63636315',
                    }}
                >
                <div className={clsx('flex flex-col justify-between h-full transition-opacity', 
                    expanded ? 'opacity-100 delay-200 duration-150' : 'opacity-0 delay-0 duration-75 pointer-events-none select-none')}>
                    <div className='flex flex-col gap-3 pb-3'>
                        <div  className="flex gap-6 items-center hover:cursor-pointer mb-11"
                            onClick={()=> {navigate(showRetailDashboard ? "/dashboard" : "/portal/my-cars")}} >
                            <LeftArrow />
                            <p className="text-subtitle text-[20px]">Επιστροφή στο My Cars</p>
                        </div>
                        <div className='flex flex-row justify-between items-center'>
                            <p className='text-sm font-bold'>{carInfo?.MakeName} {carInfo?.ModelName}</p>
                            <p className='text-sm font-bold'>{carInfo?.plateno}</p>
                        </div>
                        <CarImageCard size="extra-small" withDetails={false}/>
                        {state?.options?.tyresChange && <div className='w-full flex flex-col gap-2 items-center -mt-3 px-5 py-3 border border-fadedgrey rounded-xl'>
                            <WheelIcon width='20' height='20' color='#282828' />
                            <div>
                                <p className='text-sm text-center'>Πληροφορίες ελαστικών:</p>
                                <p className='text-sm text-center'>1. Πλάτος</p>
                                <p className='text-sm text-center'>2. Ύψος/Προφίλ</p>
                                <p className='text-sm text-center'>3. Εσωτ. διάμετρος</p>
                            </div>
                            <img
                                className={`w-[150px]`}
                                alt={`change_tyres_guide`}
                                src={`/tyre_change_guide.png`}
                            />
                        </div>}
                        {state?.options?.bodyWork && <div className='w-full flex flex-col gap-2 items-center px-5 py-3 border border-fadedgrey rounded-xl'>
                            <WarningCircleIcon width='20' height='20' color='#282828' />
                                <p className='text-sm text-center'>Για εργασίες φανοποιίας, θα χρειαστείς:</p>
                            <div className='flex flex-col justify-center'>
                                <p className='text-sm text-center'>• φωτογραφίες της ζημιάς</p>
                                <p className='text-sm text-center'>• συμπληρωμένη δήλωση ατυχήματος</p>
                                <span
                                    onClick={() => {
                                        try {
                                            handleAccidentReportDownloadClick()
                                        } catch(e) {
                                            console.warn(e)
                                        }
                                    }}
                                    className="text-sm text-center cursor-pointer font-semibold"
                                >
                                    Κατέβασε τη φόρμα εδώ
                                </span>
                            </div>
                        </div>}
                    </div>
                    <div className='flex flex-col'> 
                        {!isTesla && state?.hasUsertouchedCheckboxes && state?.step === 1 && <div>
                            {state?.optionsEligibility?.standarizedService && !state?.options?.standarizedService && 
                                <AlertBanner severity="info" className='pt-1 pb-1'>
                                    <div className='flex flex-row gap-[14px] justify-start align-top p-3'>
                                        <CheckCircleIcon width='20' height='20' className={'stroke-[#2E9BFF] shrink-0'} />
                                        <p className='text-sm'>Δικαιούσαι τακτικό service.</p>
                                    </div>
                                </AlertBanner>
                            }
                            {state?.optionsEligibility?.tyresChange && !state?.options?.tyresChange &&
                                <AlertBanner severity="info" className='pt-1 pb-1'>
                                    <div className='flex flex-row gap-[14px] justify-start align-top p-3'>
                                        <CheckCircleIcon width='20' height='20' className={'stroke-[#2E9BFF] shrink-0'} />
                                        <p className='text-sm'>Δικαιούσαι αντικατάσταση ελαστικών.</p>
                                    </div>
                                </AlertBanner>
                            }
                            {state?.optionsEligibility?.bodyWork && !state?.options?.bodyWork &&
                                <AlertBanner severity="info" className='pt-1 pb-1'>
                                    <div className='flex flex-row gap-[14px] justify-start align-top p-3'>
                                        <CheckCircleIcon width='20' height='20' className={'stroke-[#2E9BFF] shrink-0'} />
                                        <p className='text-sm'>Δικαιούσαι εργασίες φανοποιίας.</p>
                                    </div>
                                </AlertBanner>
                            }
                        </div>}
                        {/* {state?.calendarValues?.selectedSlots?.length === 3 && <AlertBanner severity="warning" className='pt-1 pb-1'>
                            <div className='flex flex-col gap-[14px] justify-center align-top p-3'>
                                <WarningCircleIcon color='#FF922E' className='w-5 h-5 shrink-0' />
                                <p className='text-sm'>Δεν μπορείς να διαλέξεις πάνω από 3 ημερομηνίες / ώρες. Αφαίρεσε κάποια από τις επιλογές σου για να προσθέσεις νέα.</p>
                                <div className='flex flex-col justify-center'>
                                    <span
                                        onClick={() => {
                                            dispatch({
                                                type: 'CLEAR_TIMESLOTS',
                                            })
                                        }}
                                        className="text-sm text-[#D4002A] text-center cursor-pointer font-semibold"
                                    >
                                        Διαγραφή όλων
                                    </span>
                                </div>
                            </div> 
                        </AlertBanner>} */}
                        {state?.serviceFlowId !== 0 && !isTesla && !state?.optionsEligibility?.standarizedService && state?.step === 1 && <AlertBanner severity="warning" className='pt-1 pb-1'>
                            <div className='flex flex-row gap-[14px] items-center align-top p-3'>
                                <WarningCircleIcon color='#FF922E' className='w-5 h-5 shrink-0' />
                                <p key='service-alert' className='text-sm'>{state?.optionsComputed?.standarizedService?.message}</p>
                            </div> 
                        </AlertBanner>}
                        {state?.serviceFlowId !== 0 && !isTesla && !state?.optionsEligibility?.tyresChange && state?.step === 1 && <AlertBanner severity="warning" className='pt-1 pb-1'>
                            <div className='flex flex-row gap-[14px] items-center align-top p-3'>
                                <WarningCircleIcon color='#FF922E' className='w-5 h-5 shrink-0' />
                                <p key='tyres-alert' className='text-sm'>{state?.optionsComputed?.tyresChange?.message}</p>
                            </div>
                        </AlertBanner>}
                        {state?.serviceFlowId !== 0 && !isTesla && !state?.optionsEligibility?.bodyWork && state?.step === 1 && <AlertBanner severity="warning" className='pt-1 pb-1'>
                            <div className='flex flex-row gap-[14px] items-center align-top p-3'>
                                <WarningCircleIcon color='#FF922E' className='w-5 h-5 shrink-0' />
                                <p key='bodywork-alert' className='text-sm'>{state?.optionsComputed?.bodyWork?.message}</p>
                            </div>
                        </AlertBanner>
                        }

                        <div className='flex flex-row justify-center pt-3'>
                            <Button
                                className={
                                    "rounded-full w-[200px] border border-[#A5A5A5] flex py-2 px-5 items-center mb-6"
                                }
                                onClick={() => {
                                    // navigate("/service/notifications_guide");
                                    window.open("/service/notifications_guide", "_blank", "noopener,noreferrer");
                                }}
                                >
                                <WarningIcon />
                                <p className="text-body pl-[14px]">Οδηγός ενδείξεων</p>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            {expanded ? (
                <CollapseIcon
                onClick={() => {
                    setExpanded(!expanded);
                }}
                className={'hover:cursor-pointer h-full'}
                />
            ) : (
                <ExpandIcon
                onClick={() => {
                    setExpanded(!expanded);
                }}
                className={'hover:cursor-pointer h-full'}
                />
            )}
            </div>
        </div>
    );
};
